import PropTypes from 'prop-types';
import cc from 'classcat';

import styles from './styles.module.scss';

const Container = ({ children, className, outerClassName, role, size }) => (
  <div className={cc([styles.container, outerClassName])}>
    <div className={cc([styles[size], className])} role={role}>
      {children}
    </div>
  </div>
);

Container.propTypes = {
  className: PropTypes.string,
  outerClassName: PropTypes.string,
  role: PropTypes.string,
  size: PropTypes.oneOf(['full', 'narrow']),
};

Container.defaultProps = { size: 'full' };

export default Container;
